import ExteriorScreen from './ExteriorScreen'

export default ExteriorScreen
